import Link from "next/link";
import { useAuth } from "../auth";
import NavLanding from "../components/NavLanding";

function Home(): React.ReactElement {
  const { isAuthenticated, loading } = useAuth();

  return (
    <div>
      <NavLanding authLoading={loading} authenticated={isAuthenticated} />
      <h2 className="text-xl mb-3">Purpose</h2>
      <p className="landing-copy">
        The internet and our devices that connect to it should make it easier to retrieve, make
        sense of, and make connections between the things we read and learn. Instead, they are
        making absorbing information harder. We want to solve this problem and create a sustainable
        business around it.
      </p>
    </div>
  );
}

export default Home;
